import { createSlice } from '@reduxjs/toolkit'
import * as Yup from 'yup'

export const HpChoiceSchema = Yup.object().shape({
  heatPumpType: Yup.string().required(),
  typologie: Yup.mixed().when('heatPumpType', {
    is: '1',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  captage: Yup.mixed().when('heatPumpType', {
    is: '2',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  utilisation: Yup.mixed().when('heatPumpType', {
    is: '3',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  energie: Yup.mixed().when('heatPumpType', {
    is: '3',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  alimentation: Yup.string().required(),
  abonnement: Yup.string().required(),
  releveChaudiere: Yup.string().required(),
  anneeChaudiere: Yup.mixed().when('releveChaudiere', {
    is: 'chaudiere',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  typeChaudiere: Yup.mixed().when('releveChaudiere', {
    is: 'chaudiere',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  energieChaudiere: Yup.mixed().when('releveChaudiere', {
    is: 'chaudiere',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  puissanceChaudiere: Yup.mixed().when('releveChaudiere', {
    is: 'chaudiere',
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),
  typeECS: Yup.string().required(),
  nbOccupants: Yup.mixed().when('typeECS', {
    is: (value: any) => value === '' || value === 'sans',
    then: () => Yup.mixed(),
    otherwise: () => Yup.string().required(),
  }),
  DHWChoice2: Yup.mixed().when('heatPumpType', {
    is: "1",
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),

  delay: Yup.mixed().when('isDelayOpen', {
    is: (value: any) => { return value === true },
    then: () => Yup.string().required(),
    otherwise: () => Yup.mixed(),
  }),

  isDelayOpen: Yup.boolean(),
})

export const hpChoiceDefaultForm = {
  heatPumpType: '1',
  heatPumpType_i18nCode: 'AEROTHERMAL',
  typologie: '0',
  typologie_i18nCode: 'SELECT_TYPO_IND',
  captage: undefined,
  captage_i18nCode: '',
  utilisation: undefined,
  utilisation_i18nCode: '',
  energie: undefined,
  energie_i18nCode: '',
  alimentation: '',
  alimentation_i18nCode: '',
  abonnement: '',
  abonnement_i18nCode: '',
  releveChaudiere: 'sans',
  releveChaudiere_i18nCode: 'NON',
  anneeChaudiere: '',
  anneeChaudiere_i18nCode: '',
  typeChaudiere: '',
  typeChaudiere_i18nCode: '',
  energieChaudiere: '',
  energieChaudiere_i18nCode: '',
  puissanceChaudiere: '',
  puissanceChaudiere_value: '',
  typeECS: '',
  typeECS_i18nCode: '',
  nbOccupants: '',
  DHWChoice2: '',
  DHWChoice2_i18nCode: '',
  delay: '',
  isDelayOpen: false,
}

const initialState = {
  form: { ...hpChoiceDefaultForm },
}

export type HpChoiceForm = typeof hpChoiceDefaultForm

export const HpChoiceSlice = createSlice({
  name: 'hpChoice',
  initialState,
  reducers: {
    initNewProject(state) {
      state.form = { ...hpChoiceDefaultForm }
    },
  },
})

//   form = { ...this.defaultForm }

//   constructor() {
//     makeObservable(this, {
//       form: observable,
//       initNewProject: action,
//       updateHeatPumpType: action
//     })
//   }

//   updateHeatPumpType(code, label) {
//     this.form.heatPumpType = code
//     this.form.heatPumpType_i18nCode = label

//     switch (code) {
//       case '1':
//         this.form.captage = ''
//         this.form.utilisation = ''
//         this.form.energie = ''
//         break
//       case '2':
//         this.form.typologie = ''
//         this.form.utilisation = ''
//         this.form.energie = ''
//         break
//       case '3':
//         this.form.captage = ''
//         this.form.typologie = ''
//         break
//     }
//   }
// }
